export default "__VITE_ASSET__DvSJV5Q___"